module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_kongdoo_m2.601eacc20b6861448f923e51ec24b698.png";